import { Output, EventEmitter, OnInit, Input } from '@angular/core';
import { WorkFieldDateChangeEvent } from '../../../events/work-field-date-change-event';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';

export class E5coreUiWorkFieldTypeDateBaseComponent extends E5coreUiWorkFieldTypeComponentBase implements OnInit {

  @Input() date:Date ;
  @Output() valueChange = new EventEmitter<WorkFieldDateChangeEvent>() ;

  ngOnInit() {
  }
  
  changeValue($event: Date) {
    this.valueChange.emit({$event: $event, value: $event}) ;
  }
}
